/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {format} from 'date-fns';

const standardDateFormat = 'd MMM yyyy, h:mm a';

export const formatDateCommon = (date: Date | number) => {
  return format(date, standardDateFormat);
};

export const toDate = (date: any) => {
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return date;
  return formatDateCommon(parsedDate);
};
